/* API module for MaterialherstellerController */

import { api } from './http';
import { toApiError } from './errors';
import type {
  MaterialherstellerCreateRequestDTO,
  MaterialherstellerResponseDTO,
  MaterialherstellerUpdateRequestDTO,
} from './types';

export type Id = number;

export async function getAll(): Promise<MaterialherstellerResponseDTO[]> {
  try {
    const { data } = await api.get<MaterialherstellerResponseDTO[]>('Materialhersteller');
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

export async function getById(id: Id): Promise<MaterialherstellerResponseDTO> {
  try {
    const { data } = await api.get<MaterialherstellerResponseDTO>(`Materialhersteller/${id}`);
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

export async function create(payload: MaterialherstellerCreateRequestDTO): Promise<MaterialherstellerResponseDTO> {
  try {
    const { data } = await api.post<MaterialherstellerResponseDTO, MaterialherstellerCreateRequestDTO>('Materialhersteller', payload);
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

export async function update(id: Id, payload: MaterialherstellerUpdateRequestDTO): Promise<MaterialherstellerResponseDTO> {
  try {
    const { data } = await api.put<MaterialherstellerResponseDTO, MaterialherstellerUpdateRequestDTO>(`Materialhersteller/${id}`, payload);
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

export async function remove(id: Id): Promise<void> {
  try {
    await api.delete<void>(`Materialhersteller/${id}`);
  } catch (e) {
    throw toApiError(e);
  }
}
